module.exports = __webpack_public_path__ + "assets/media/1.c8e8a15e.wav";